import React from 'react';
import ClassSelectPage from './ClassSelectPage';

const DutySelectPage = () => {
  return <ClassSelectPage type="duty" />;
};

export default DutySelectPage;







